import { render, staticRenderFns } from "./AppTooltip.vue?vue&type=template&id=3bf07804&scoped=true&"
import script from "./AppTooltip.vue?vue&type=script&lang=ts&"
export * from "./AppTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf07804",
  null
  
)

export default component.exports